import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import { useTranslation } from 'react-i18next';

const TrafficTotalContext = createContext(null);

export function SwItsBisPssngrDataProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/busoprt/GetBusPssngrData");
            if (response.status === 200) {
                const data = response.data;
                setCurrentData({
                    updateTime: data.updateTime,
                    totalCnt: data.total.inCnt,
                    totalOutCnt: data.total.outCnt,
                    pssngrCnt: data.type,
                    diffPct : data.diffPct,
                    rangeTotalIn:data.total.rangetotalInCnt
                });

            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <TrafficTotalContext.Provider value={currentData}>
            {children}
        </TrafficTotalContext.Provider>
    );
}

const BUS_TYPE_LABELS = {
    13: '시내',
    14: '광역',
    30: '마을',
    50: 'DRT',
};

const BUS_TYPE_COLOR_CLASSES = {
    14: 'red',   // 광역
    13: 'gr',    // 시내
    30: 'ylw',   // 마을
    50: 'white'  // DRT (예비)
};

export function SwItsBisPssngrTotalInfo() {
    const currentData = useContext(TrafficTotalContext);
    const { t, i18n } = useTranslation(); 
    if (!currentData || !currentData.pssngrCnt) return null;
    const ORDER = [14, 13, 30];

    // 각 타입에 대한 기본 데이터 객체 생성
    const defaultPssngrData = ORDER.map(type => ({
        type: type.toString(),
        inCnt: 0,
        // 다른 필요한 기본값들
    }));

    // 실제 데이터가 있는 경우 기본 데이터를 대체
    const existingTypes = currentData.pssngrCnt.map(item => Number(item.type));
    const sortedPssngrCnt = defaultPssngrData.map(defaultItem => {
        const matchingItem = currentData.pssngrCnt.find(item => Number(item.type) === Number(defaultItem.type));
        return matchingItem || defaultItem;
        // const colorClass = BUS_TYPE_COLOR_CLASSES[item.type] || "gr";

    });

    return (
        <div className='L_2m inner'>
            <div className='titWrap flx j_spc_btw'>
                {/* <h2 className="boxTit" style={{color:'var(--iv-10)'}}>버스 이용자</h2> */}
               <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-10)'}}>{t('RidershipStatus')}
                </h2>
            </div>
            <div className='busUserConts flx'>
                <div className='left innerBg flx flx_col a_center j_center'>
                    {/* <p className='subTit'>오늘 이용객</p> */}
                    <div className='flx flx_col a_center j_center' style={{ marginTop: '10px', }}>
                        <div className='flx a_center j_center'>
                            <span className='unit' style={{ margin: '0 20px 0 10px', fontSize: 'var(--ft-28)', fontWeight: 'var(--ft-SemiBold)' }}>승차</span>
                            <span className='fgr' style={{ fontSize: 'var(--ft-56)', fontWeight: 'var(--ft-Bold)', marginBottom: '6px', }}>
                                {currentData.totalCnt.toLocaleString()}
                            </span>
                            <span className='unit' style={{ margin: '0 10px', fontSize: 'var(--ft-28)', }}>명&nbsp;/&nbsp;시</span>
                        </div>
                        <div className='flx a_center j_center'>
                            <span className='unit' style={{ margin: '0 20px 0 10px', fontSize: 'var(--ft-28)', fontWeight: 'var(--ft-SemiBold)' }}>하차</span>
                            <span className='fgr' style={{ fontSize: 'var(--ft-56)', fontWeight: 'var(--ft-Bold)', marginBottom: '6px', }}>
                                {currentData.totalOutCnt.toLocaleString()}
                            </span>
                            <span className='unit' style={{ margin: '0 10px', fontSize: 'var(--ft-28)', }}>명&nbsp;/&nbsp;시</span>
                        </div>
                    </div>
                </div>
                <div className='right grid flx flx_col a_center j_spc_btw'>
                    {sortedPssngrCnt.map(item => {
                        const colorClass = BUS_TYPE_COLOR_CLASSES[item.type] || "gr";
                        return (
                            <div
                                key={item.type}
                                className={`gridLi flx a_center j_spc_btw`}
                                style={{ borderRadius: '32px', }}
                            >
                                <span className='grpTit'>{BUS_TYPE_LABELS[item.type] || `유형 ${item.type}`}</span>
                                <div className="flx a_flx_end j_flx_end">
                                    <span className="unit" style={{ marginBottom: '10px', marginLeft: '10px', marginRight: '8px' }}>승차</span>
                                    <span className= {`${colorClass} fgr`}>
                                        {(item.inCnt || 0).toLocaleString()}
                                    </span>
                                    <span className="unit" style={{ marginBottom: '10px', marginLeft: '10px' }}>명</span>
                                    <span className="sls" style={{ fontSize: 'var(--ft-30)', margin: '0 8px 6px 12px' }}>|</span>
                                    <span className="unit" style={{ marginBottom: '10px', marginLeft: '10px', marginRight: '8px' }}>하차</span>
                                    <span className= {`${colorClass} fgr`}>
                                        {(item.outCnt || 0).toLocaleString()}
                                    </span>
                                    <span className="unit" style={{ marginBottom: '10px', marginLeft: '10px' }}>명</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

// 전월대비 추후 수정 필요
export function SwItsBisPssngrTotalInfoDash() {

    const { t, i18n } = useTranslation(); 

    const currentData = useContext(TrafficTotalContext);
    if (!currentData || !currentData.pssngrCnt) return null;
    const date = new Date(currentData.updateTime);
    
  let hours = date.getHours() - 1;
  if (hours < 0) hours = 23;
  hours = String(hours).padStart(2, "0");

  const isIncrease = currentData.totalCnt >= currentData.rangeTotalIn;
  const changeValueClass = isIncrease ? "plus" : "minus";
  const sign = currentData.diffPct > 0 ? "+" : "";
    return (
        <div className='inner L_3m flx flx_col a_center j_center'  style={{padding: '40px 20px'}}>
            <div className='titWrap flx j_center'>
                 <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>{t('BusRidership')}</h2>
            </div>
            <div className='flx flx_col a_center'>
                <div className='flx a_flx_end'>
                    <span className='subTxt' style={{fontSize:'var(--ft-28)', margin:'0 8px 14px 0', }}>승차</span>
                    <span className='nbr' style={{fontSize:'var(--ft-56)'}}> {currentData.totalCnt.toLocaleString()}</span>
                    <span className='subTxt' style={{fontSize:'var(--ft-28)', margin:'0 0px 14px 8px',}}>명/시</span>
                    <span className='subTxt sls' style={{ margin:'0  10px 6px',}}>|</span>
                    <div className='flx a_flx_end'>
                    <span className='subTxt' style={{fontSize:'var(--ft-28)', margin:'0 8px 14px 0',}}>하차</span>
                    <span className='nbr' style={{fontSize:'var(--ft-56)'}}>{currentData.totalOutCnt.toLocaleString()}</span>
                    <span className='subTxt' style={{fontSize:'var(--ft-28)', margin:'0 0 14px 8px',}}>명/시</span>
                </div>
                </div>
                <div className="flx a_center j_center">
                    <span className="cmpr" style={{ marginRight: "10px" }}>
                      월 평균
                    </span>
                    <span className="cmpr" style={{ marginRight: "10px" }}>
                        {hours}시 승차 대비
                    </span>
                    <span className={`cmpr ${changeValueClass}`} style={{ fontWeight: "var(--ft-Bold)" }}>
                        {sign}
                        {currentData.diffPct}
                    </span>
                    <span className="cmpr" style={{ marginLeft: "10px" }}>
                        %
                    </span>
                </div>
            </div>
        </div>
    );
}






